export default {
  // ========== Chart types ==========
  chartType: 'Chart type:',
  bar: 'Bar',
  line: 'Line',
  pie: 'Pie',
  doughnut: 'Doughnut',
}
